import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getPlacedOrders(context, payload) {
        return axios
            .get(`/reports/report-placed-orders-by-date?${payload.query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o złożonych zamówieniach nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getOrdersInProgress({commit}, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate, query = payload.query

        return axios
            .get(`/reports/report-orders-in-progress${paginate}${query}`)
            .then(response => {
                commit('GET_ORDERS_IN_PROGRESS', response.data)
                
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o zamówieniach w toku nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateOrdersInProgressReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/reports/report-orders-in-progress?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
}